function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30,49.9c-15.3,0-22.9-7.8-28.9-16.3l-0.6-0.9l0.6-0.9c6-8.5,13.6-16.3,28.9-16.3s22.9,7.8,28.9,16.3l0.6,0.9l-0.6,0.9 C53.3,41.7,45.5,49.9,30,49.9z M4.3,32.7C9.6,40.2,16.6,46.8,30,46.8c13.5,0,20.4-6.7,25.7-14.1C50.3,25.3,43.3,18.6,30,18.6 C16.7,18.6,9.7,25.3,4.3,32.7z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M3.5,23.3l-2.2-2.1C9.2,13,18.3,9.2,30,9.2c11.8,0,20.9,3.8,28.7,11.8l-2.2,2.1C49.3,15.7,40.9,12.2,30,12.2 C19.2,12.2,10.8,15.7,3.5,23.3z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30,44.4c-6.4,0-11.7-5.2-11.7-11.7c0-6.4,5.2-11.7,11.7-11.7s11.7,5.2,11.7,11.7C41.7,39.2,36.4,44.4,30,44.4z M30,24.1 c-4.7,0-8.6,3.9-8.6,8.6c0,4.7,3.9,8.6,8.6,8.6s8.6-3.9,8.6-8.6C38.6,28,34.7,24.1,30,24.1z"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30,37.9c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2C35.2,35.6,32.9,37.9,30,37.9z M30,30.6 c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1C32.1,31.5,31.2,30.6,30,30.6z"
}))));

var SvgEye = function SvgEye(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/eye.73b5c779.svg";
export { SvgEye as ReactComponent };